module.exports = __webpack_public_path__ + "static/user-testing-1-dfe66288c75b183435cafb997c9993e1.jpg";